// Dashboard canvas entrypoint that combines the split grid, drag and resize modules.
import dashboardLayoutEditorCanvasGrid from "./dashboardLayoutEditorCanvasGrid";
import dashboardLayoutEditorCanvasDrag from "./dashboardLayoutEditorCanvasDrag";
import dashboardLayoutEditorCanvasResize from "./dashboardLayoutEditorCanvasResize";

const dashboardLayoutEditorCanvas = {
    /**
     * Set dashboard widget context menu.
     *
     * @param {*} referenceId
     */
    setDashboardWidgetContextMenu(referenceId = null) {
        this.dashboardCanvasContextMenuReferenceId = referenceId;
    },
    /**
     * Set dashboard block context menu.
     *
     * @param {*} referenceId
     */
    setDashboardBlockContextMenu(referenceId = null) {
        this.setDashboardWidgetContextMenu(referenceId);
    },
};

export default dashboardLayoutEditorCanvas;

Object.assign(
    dashboardLayoutEditorCanvas,
    dashboardLayoutEditorCanvasGrid,
    dashboardLayoutEditorCanvasDrag,
    dashboardLayoutEditorCanvasResize,
);
